import { z } from 'zod'
import { ProviderId, SuggestionStatus } from '../enums'
import { Id, Instant, Ratio } from './primitives'

export const GROUNDING_SOURCE_KINDS = ['kb_source', 'corpus_entry'] as const
export const GroundingSourceKind = z.enum(GROUNDING_SOURCE_KINDS)
export type GroundingSourceKind = z.infer<typeof GroundingSourceKind>

export const GroundingSource = z.object({
  kind: GroundingSourceKind,
  id: Id,
  title: z.string(),
  excerpt: z.string(),
  similarity: Ratio,
})
export type GroundingSource = z.infer<typeof GroundingSource>

export const GROUNDING_SOURCE_MAX = 6

export const GroundingSourceText = z.object({
  id: Id,
  kind: GroundingSourceKind,
  title: z.string(),
  text: z.string(),
})
export type GroundingSourceText = z.infer<typeof GroundingSourceText>

const distinct = (ids: readonly string[]): boolean => new Set(ids).size === ids.length

export const SuggestRequest = z.object({
  sourceIds: z
    .array(Id)
    .min(1)
    .max(GROUNDING_SOURCE_MAX)
    .refine(distinct, 'sourceIds must not repeat a source')
    .optional(),
})
export type SuggestRequest = z.infer<typeof SuggestRequest>

export const Suggestion = z.object({
  id: Id,
  status: SuggestionStatus,
  text: z.string().nullable(),
  provider: ProviderId.nullable(),
  model: z.string().nullable(),
  confidence: Ratio.nullable(),
  threshold: Ratio.nullable(),
  grounding: z.array(GroundingSource),
  error: z.string().nullable(),
  createdAt: Instant,
})
export type Suggestion = z.infer<typeof Suggestion>

export const SuggestionAccepted = z.object({ suggestionId: Id, status: SuggestionStatus })
export type SuggestionAccepted = z.infer<typeof SuggestionAccepted>
